<template>
  <div class="editor">
    <content-tab-bar :tabs="tabs" :selectedTab.sync="selectedTab" :links="false"></content-tab-bar>
    <log-details v-if="selectedTab === 'Summary'" :log="log" :related="log.parsed.related">
    </log-details>
    <alert-related-processes
      v-else-if="selectedTab.startsWith('Processes')"
      :processes="log.parsed.related.processes"
      :related="log.parsed.related">
    </alert-related-processes>
    <alert-related-files
      v-else-if="selectedTab.startsWith('Files')"
      :files="log.parsed.related.files"
      :related="log.parsed.related">
    </alert-related-files>
    <alert-related-binaries
      v-else-if="selectedTab.startsWith('Binaries')"
      :binaries="log.parsed.related.binaries"
      :related="log.parsed.related">
    </alert-related-binaries>
    <alert-related-groups
      v-else-if="selectedTab.startsWith('Groups')"
      :groups="log.parsed.related.groups"
      :related="log.parsed.related">
    </alert-related-groups>
    <alert-related-users
      v-else-if="selectedTab.startsWith('Users')"
      :users="log.parsed.related.users"
      :related="log.parsed.related">
    </alert-related-users>
    <alert-json v-else-if="selectedTab.startsWith('Json')" :data="log.log"></alert-json>
  </div>
</template>

<script>
import ContentTabBar from '@/components/ContentTabBar.vue';
import LogDetails from '@/views/logs/tabs/LogDetails.vue';
import AlertRelatedProcesses from '@/views/alerts/tabs/AlertRelatedProcesses.vue';
import AlertRelatedFiles from '@/views/alerts/tabs/AlertRelatedFiles.vue';
import AlertRelatedBinaries from '@/views/alerts/tabs/AlertRelatedBinaries.vue';
import AlertRelatedUsers from '@/views/alerts/tabs/AlertRelatedUsers.vue';
import AlertRelatedGroups from '@/views/alerts/tabs/AlertRelatedGroups.vue';
import AlertJson from '@/views/alerts/tabs/AlertJson.vue';

export default {
  name: 'Log',
  components: {
    ContentTabBar,
    LogDetails,
    AlertJson,
    AlertRelatedProcesses,
    AlertRelatedFiles,
    AlertRelatedBinaries,
    AlertRelatedGroups,
    AlertRelatedUsers,
  },
  props: {
    log: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedTab: 'Summary',
    };
  },
  computed: {
    tabs() {
      return [
        {
          label: 'Summary',
          tab: 'Summary',
          icon: 'summary',
        },
        {
          label: `Processes (${this.log.parsed.related.processes.length})`,
          icon: 'process_circle',
        },
        {
          label: `Files (${this.log.parsed.related.files.length})`,
          icon: 'file_circle',
        },
        {
          label: `Binaries (${this.log.parsed.related.binaries.length})`,
          icon: 'binary_circle',
        },
        {
          label: `Users (${this.log.parsed.related.users.length})`,
          icon: 'user',
        },
        {
          label: `Groups (${this.log.parsed.related.groups.length})`,
          icon: 'group',
        },
        {
          label: 'Json',
          icon: 'json',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.editor {
  width: 100%;
  height: 100%;
}
</style>
